import {
  SignInWithApple,
  SignInWithAppleResponse,
} from "@capacitor-community/apple-sign-in";
import { AppConfig } from "../../app.config";

export const appleAuth = async (
  state: string,
  nonce: string
): Promise<SignInWithAppleResponse> => {
  try {
    const clientId =
      AppConfig.META_DATA.appID === "member"
        ? "jp.mymember.web"
        : "jp.patoforcast.web";
    const redirectURI =
      AppConfig.META_DATA.appID === "member"
        ? "https://mymember.fun/api/v1/apple_auths/callback"
        : "https://pato.today/api/v1/apple_auths/callback";
    const result: SignInWithAppleResponse = await SignInWithApple.authorize({
      clientId: clientId,
      redirectURI: redirectURI,
      scopes: "email name",
      state: state,
      nonce: nonce,
    });
    return result;
  } catch (error) {
    console.error("Apple Sign-In Error:", error);
    return error;
  }
};
